/******** common for both product and cart pages ***start***/

var errors = {'size':[],'qty':[]};
var $selVarEle = $('select[name=id]');
var currentProductPriceJson = false;

function htmlEntities(str) {
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

function isset(v){
  return typeof(v) != "undefined" && v != null;
}

function isObjectEqual(obj1, obj2){
  var obj1Keys = Object.keys(obj1);
  var obj2Keys = Object.keys(obj2);
  if(obj1Keys.length !== obj2Keys.length){
    return false;
  }
  for(var i=0; i < obj1Keys.length; i++){
    var key = obj1Keys[i];
    if(obj1[key] !== obj2[key]){
      return false;
    }
  };
  return true;
}

function objectifyForm($form) {//serialize data function
  var formArray = $form.serializeArray();
  var returnArray = {
    properties: {}
  };
  for (var i = 0; i < formArray.length; i++){
    if(formArray[i]['name'].includes('properties')){
      returnArray.properties[formArray[i]['name'].split('[')[1].replace(']','')] = formArray[i]['value'];
    }else{
      returnArray[formArray[i]['name']] = formArray[i]['value'];
    }
  }
 
  return returnArray;
}

function getPricingObject(selectedVariantBarcode, priceJson){ // generates an object from json file which contains discounted prices of product and addons, else returns blank object
  var priceObject = {
    prices : {},
    overlamination : {},
    foil : {},
    numbering : {},
    matte : {}
  };
  if(selectedVariantBarcode){
    var split = selectedVariantBarcode.split("_");
    var rowNumber = split[split.length-1];
    if(parseInt(rowNumber) > 0 && selectedVariantBarcode != "" && typeof priceJson['quantity_breaks'] == "object"){
      priceJson['quantity_breaks'].forEach(function(qty,index){
        if(typeof priceJson['row_'+rowNumber] == "object"){
          priceObject.prices[qty] = priceJson['row_'+rowNumber][index];
        }
        if(typeof priceJson['overlam_'+rowNumber] == "object"){
          priceObject.overlamination[qty] = priceJson['overlam_'+rowNumber][index];
        }else if(typeof priceJson['overlam_1'] == "object"){
          priceObject.overlamination[qty] = priceJson['overlam_1'][index];
        }
        if(typeof priceJson['foil_'+rowNumber] == "object"){
          priceObject.foil[qty] = priceJson['foil_'+rowNumber][index];
        }else if(typeof priceJson['foil_1'] == "object"){
          priceObject.foil[qty] = priceJson['foil_1'][index];
        }
        if(typeof priceJson['numbering_'+rowNumber] == "object"){
          priceObject.numbering[qty] = priceJson['numbering_'+rowNumber][index];
        }else if(typeof priceJson['numbering_1'] == "object"){
          priceObject.numbering[qty] = priceJson['numbering_1'][index];
        }
        if(typeof priceJson['matte_varnish_'+rowNumber] == "object"){
          priceObject.matte[qty] = priceJson['matte_varnish_'+rowNumber][index];
        }else if(typeof priceJson['matte_varnish_1'] == "object"){
          priceObject.matte[qty] = priceJson['matte_varnish_1'][index];
        }
      });
    }
  }
  priceObject = (Object.keys(priceObject.prices).length > 0) ? priceObject : false;
  return priceObject;
}

function calculateCustomDiscountedPrice(qtyBreak, variantQty, priceObject, type, i) {
  let discountedPrice = priceObject[type][qtyBreak];
  if (i < Object.keys(priceObject[type]).length - 1) {
    let nextQtyBreak = Object.keys(priceObject[type])[i + 1];
    let nextDiscountedPrice = priceObject[type][nextQtyBreak];
    discountedPrice = Number((((discountedPrice * qtyBreak) - (variantQty - qtyBreak) / (nextQtyBreak - qtyBreak) * ((discountedPrice * qtyBreak) - (nextDiscountedPrice * nextQtyBreak))) / variantQty).toFixed(4));
  }
  return discountedPrice;
}

function getDiscountedPrice(variantQty, priceObject, type, lot_pricing){ // calculates discounted price if applicable else returns 0
  var discountedPrice = 0;
  if(priceObject){
    var lotSize = 0;
    if(typeof priceObject[type] != 'object'){
      return parseFloat(discountedPrice);
    }
    if(isset(Object.keys(priceObject[type])[0])){
      lotSize = Object.keys(priceObject[type])[0];
      discountedPrice = priceObject[type][Object.keys(priceObject[type])[0]];
    }
    Object.keys(priceObject[type]).forEach(function(qtyBreak, i) {
      if(qtyBreak <= variantQty){
        discountedPrice = priceObject[type][qtyBreak];
        if (useQtyBreakCalculator) {
          discountedPrice = calculateCustomDiscountedPrice(qtyBreak, variantQty, priceObject, type, i);
        }
      }
    });
    if(lot_pricing && lotSize){
      discountedPrice = discountedPrice/lotSize;
    }
  }
  return parseFloat(discountedPrice.toFixed(2));
}

function getAddOnPrice(variantQty,priceObject,type){
  var discountedPrice = 0;
  if(priceObject && isset(type) && type == "overlamination" || type == "foil" || type == "numbering" || type == "matte"){
    Object.keys(priceObject[type]).forEach(function(qtyBreak) {
      if(qtyBreak <= variantQty){
        discountedPrice = priceObject[type][qtyBreak];
      }
    });
  }
  return discountedPrice;
}

function addToCart(items){
  if(!items.length){
    return false;
  }
  if (window.__addToCartInFlight) {
    return false;
  }
  window.__addToCartInFlight = true;
  $('#addToCart').addClass('disabled').prop('disabled', true);
  var __cartAddStartedAt = Date.now();
  if (typeof ccLogProofStep === 'function') {
    ccLogProofStep('cart_add_start', 'Cart add (new line) started', {
      project_id: (typeof window.project_id !== 'undefined' && window.project_id) || '',
      item_count: items.length,
      started_at: formatProofTimestamp ? formatProofTimestamp(__cartAddStartedAt) : '',
      started_at_ms: __cartAddStartedAt
    });
  }
  $.ajax({ // adding merged items to the cart
    type    : "POST",
    url     : '/cart/add.js',
    data    : {items : items},
    dataType  : 'json',
    success : function(){
      var __cartAddEndedAt = Date.now();
      if (typeof ccLogProofStep === 'function') {
        ccLogProofStep('cart_add_complete', 'Cart add (new line) completed', {
          started_at: formatProofTimestamp ? formatProofTimestamp(__cartAddStartedAt) : '',
          completed_at: formatProofTimestamp ? formatProofTimestamp(__cartAddEndedAt) : '',
          duration_ms: __cartAddEndedAt - __cartAddStartedAt,
          item_count: items.length
        });
      }

      try {
        var canvasStorage = window.localStorage.getItem('customers_canvas');
        var canvasData = canvasStorage ? JSON.parse(canvasStorage) : null;
        if (canvasData && canvasData.from_saved_artwork_edit && !canvasData.cart_item_key) {
          window.localStorage.removeItem('customers_canvas');
          if (typeof storageUserData !== 'undefined') {
            storageUserData = null;
          }
        }
      } catch (err) {}
      if (window.location.search.indexOf('no_cart_redirect=1') === -1) {
        window.location.href = '/cart';
      } else {
        console.log('[PROOF][debug] cart redirect suppressed (no_cart_redirect=1)');
        $('#product-canvas-loader').removeClass('loading');
      }
    },
    error: function(xhr, status, error){
      console.error('[CART_ADD_FAILED]', { xhr: xhr, status: status, error: error });
      $('#product-canvas-loader').removeClass('loading');
      $('.canvas-close-button').removeClass('disabled-during-checkout');
      if (window.stompSentryCapture) {
        window.stompSentryCapture({
          message: 'Add to cart request failed',
          level: 'error',
          tags: {
            source: 'pricing.js',
            stage: 'cart_add_failed'
          },
          extra: {
            status: status || '',
            status_code: xhr && xhr.status,
            response_text: xhr && xhr.responseText ? String(xhr.responseText).slice(0, 500) : ''
          }
        });
      }
    },
    complete: function(){
      setTimeout(function(){
        $('#addToCart').removeClass('disabled').prop('disabled', false);
        window.__addToCartInFlight = false;
      },1000);
    },
  });
}

function setQtyOptions(priceObject, $ele, lot_pricing, defaultQty){
  var basePrice = $selVarEle.find('[value='+$selVarEle.val()+']').first().data('price')/100;
  let qtyOptions = [];
  let tableQtyOptions = []
  var qty = $ele.data('qty');
  let cartQty = 0;
  let counter = 0;
  if(page == "product"){
    cartQty = getQty() - $('#quantity').val(); 
  }

  qty = (!isset(qty) || isNaN(qty) || qty <= 0)? false : qty;
  lot_pricing = isset(lot_pricing)? lot_pricing : false;
  var customAvailable = false;

  if(typeof priceObject == "object"){
    Object.keys(priceObject.prices).forEach(function(qBreak, i) {
      if(parseFloat(qBreak) + cartQty <= cartQty){
        counter = i;
      }
    });

    Object.keys(priceObject.prices).forEach(function(qtyBreak, i){
      var discPrice = priceObject.prices[qtyBreak] 
      var savingPercentText = "";
      let initialPrice = 0;
      /*if(isset(basePrice) && !isNaN(basePrice)){
        var savingPercent = 100 - (discPrice*100/basePrice);
        savingPercentText = 'Save' + Math.round(savingPercent) + '%';
        if(savingPercent <= 0){
          savingPercentText = "";
        }
      }*/
      var selected = '';
      if(defaultQty && parseInt(defaultQty) > 0 && parseInt(defaultQty) == parseInt(qtyBreak)){
        selected = ' selected';
      }
      lotSize = Object.keys(priceObject['prices'])[0];

      // if(isset(Object.keys(priceObject["prices"])[i])){
          discPrice = getDiscountedPrice(parseInt(qtyBreak) + cartQty, priceObject, 'prices', lot_pricing);
          discPrice = parseFloat(discPrice).toFixed(2);
      // }
      // console.log('qty', cartQty, parseFloat(qtyBreak))
      // Object.keys(priceObject["prices"]).forEach(function(qBreak, i) {
      //   console.log('compare', parseFloat(qBreak) + cartQty, parseFloat(qtyBreak), parseFloat(qBreak) + cartQty <= parseFloat(qtyBreak))
      //   if(parseFloat(qBreak) + cartQty <= parseFloat(qtyBreak)){
      //     discPrice = getDiscountedPrice(parseFloat(qBreak) + cartQty, priceObject, 'prices', lot_pricing);
      //   }
      // })
      // discPrice = priceObject['prices'][Object.keys(priceObject['prices'])[i]]

      initialPrice = priceObject['prices'][Object.keys(priceObject['prices'])[0]];
      // console.log('disc price', discPrice)
      // console.log('initial total price', initialPrice * qtyBreak)
      // console.log('disc total price', discPrice * qtyBreak)
      // console.log('savings percentage', Math.round(( (initialPrice * qtyBreak).toFixed(2) - (discPrice * qtyBreak).toFixed(2))/(initialPrice * qtyBreak).toFixed(2) * 100));
  


      if(lot_pricing && lotSize){
        // discPrice = discPrice/lotSize;
        initialPrice = initialPrice/lotSize;
      }
      
      let finalPrice = (qtyBreak*discPrice).toFixed(2);

      if(!isNaN(finalPrice)){
        finalPrice = Math.round(finalPrice*100)/100;
      }


      let savingPercentage = Math.round(( (initialPrice * qtyBreak).toFixed(2) - (discPrice * qtyBreak).toFixed(2))/(initialPrice * qtyBreak).toFixed(2) * 100);
      qtyOptions.push('<option value="'+parseInt(qtyBreak)+'"'+selected+'><span class="qtybrk">'+qtyBreak+'</span> <span class="savingpercent">'+savingPercentText+'</span></option>');
      tableQtyOptions.push(`<tr ${parseInt(qtyBreak) > 1000 && i >= 3 ? "class='table-row-hide'" : ''}><td data-value="${parseInt(qtyBreak)}"><div class="quantity-table--select ${$('#quantity').val() == parseInt(qtyBreak) && document.querySelector('.custom-quantity-table--select.selected') == null ? 'selected' : ''}"><span><svg xmlns="http://www.w3.org/2000/svg" width="11.532" height="9.634" viewBox="0 0 11.532 9.634"><path id="check-icon" d="M16,26l3.438,4L26,22" transform="translate(-15.242 -21.366)" fill="none" stroke="#fff" stroke-linejoin="round" stroke-width="2"/></svg></span></div></td><td>${qtyBreak}</td><td>$${parseFloat(discPrice).toFixed(2)}</td><td class="quantity-table--total">$${finalPrice.toFixed(2)}</td><td class="savings-cell ${savingPercentage <= 0 ? 'saving-hidden' : ''}"><span class="saving-percentage ${savingPercentage <= 0 ? 'saving-hidden' : ''}">- ${savingPercentage}%</span></td></tr>`);
      if (i == 0 && document.getElementById('custom-quantity-input')) {
        if(document.querySelector('#quantity-table .quantity-table--select.selected')) {
          document.getElementById('custom-quantity-input').value = document.getElementById('quantity-dropdown').value
          document.querySelector('.custom-quantity-table--select').closest('[data-value]').setAttribute('data-value', document.getElementById('quantity-dropdown').value);
          if(document.querySelector('.custom-quantity-table--select.quantity-table--select.selected')) {
            document.querySelector('.custom-quantity-table--select.quantity-table--select.selected').click()
          }
        } else {
          document.getElementById('custom-quantity-input').value = localStorage.getItem('customQuantity') == 0 ? qtyBreak : localStorage.getItem('customQuantity') ;
          document.querySelector('.custom-quantity-table--select').closest('[data-value]').setAttribute('data-value', document.getElementById('custom-quantity-input').value);
          if(document.querySelector('.custom-quantity-table--select.quantity-table--select.selected')) {
            setTimeout(() => {
              document.querySelector('.custom-quantity-table--select.quantity-table--select.selected').click()
            }, 100);
          }
        }
      }
    });

    if(!lot_pricing){
      qtyOptions.push('<option value="custom">Custom Quantity</option>');
      customAvailable = true;
    } else {
      if (document.getElementById('custom-quantity-table')) {
        document.getElementById('custom-quantity-table').style.display = 'none';
        // check if custom-quantity-table has show-custom-quantity class
        if (document.getElementById('custom-quantity-table').querySelector('.show-custom-quantity')) {
          qtyOptions.push('<option value="custom">Custom Quantity</option>');
          customAvailable = true;
        }
      }
    }
  }else{
    qtyOptions.push('<option value="custom">Custom Quantity</option>');
    customAvailable = true;
  }
  $ele.html(qtyOptions.join(''));
  if(page == "product"){
    document.querySelector('#quantity-table').innerHTML = '<tbody><tr><th></th><th>Quantity</th><th>Unit Price</th><th>Total</th><th></th></tr>'+ tableQtyOptions.join('') +'</tbody>';
  }
  const tableShowMore = document.querySelector('.show-more-dropdown');
  const tableHiddenRows = document.querySelectorAll('.table-row-hide');

  if (window.location.pathname.indexOf('/products/') !== -1) {
  if (tableHiddenRows.length == 0) {
    tableShowMore.style.display = 'none'
  } else {
    tableShowMore.style.display = 'flex'
  }
  }
  $ele.off('change').on('change',function(){
    var val = $(this).val();
    if(val == 'custom'){
      let customQty = document.getElementById('custom-quantity-input') ? document.getElementById('custom-quantity-input').value : 1;
      $(this).parent().next('input.cart_item_custom_qty').attr('type','number').val(qty === false?customQty:qty);
    }else{
      $(this).parent().next('input.cart_item_custom_qty').attr('type','hidden').val(val).change();
    }
    if(page == "product"){
      setPricing();
    }
  });
  if(qty && typeof priceObject == "object" && Object.keys(priceObject.prices).includes(String(qty))){
    $ele.val(qty);
  }else if(page == "cart"){
    $ele.val('custom');
    $ele.parent().next('input.cart_item_custom_qty').attr('type','number').val(qty);
    crossSellLotPricing = lot_pricing
  }
  
  if(page == "product"){
    $ele.change();
    if (!window._ccCartEditMode && localStorage.getItem("hasQtyOptionBeenSelected") === null) {
      $('#quantity-dropdown').prop("selectedIndex", 0);
      setTimeout(() => {
        document.querySelector('.quantity-table--select').click();
      }, 500);
      localStorage.setItem("hasQtyOptionBeenSelected", true);
    }
  }
  
  if(qtyOptions.length == 0 || (qtyOptions.length == 1 && customAvailable)){
    $ele.parents('.select-quantity').addClass('hide-select')
  }else{
    $ele.parents('.select-quantity').removeClass('hide-select')
  }
  if(page == "cart"){
    $('.select-caret-wrapper').each(function(){
      if($(this).find('select.cart_item_qty_select option').length > 0){
        $(this).show();
      }
    });
  }
}

function getBarcodeFromSku(selectedVariantSku){
  var selectedVariantBarcode = false;
  if(isset(selectedVariantSku)){
    const split = selectedVariantSku.split('row');
    if(split.length > 1){
      selectedVariantBarcode = 'row'+split[split.length-1];
    }
  }
  return selectedVariantBarcode;
}

function validatePricingJson(json, handle, callback) {
  if (!handle) {
    const paths = window.location.pathname.split("/");
    handle = paths[paths.length - 1];
  }
  return Shopify.getProduct(handle, (product) => {
    var variants = product.variants;
    let isJsonValid = true;
    let errorMessage = "";
    
    //Check if quantity_breaks element exists
    if (!json.quantity_breaks) {
      isJsonValid = false;
      errorMessage += "- quantity_breaks element is missing.";
    }

    //Check that all [barcode] elements exists
    variants.forEach(variant => {
      const variantPrice = variant.price;
      const splittedSku = variant.sku.split("-");
      const variantBarcode = `${splittedSku[splittedSku.length - 1]}`;
      if (!json[variantBarcode]) {
        isJsonValid = false;
        errorMessage += `\n- ${variantBarcode} element is missing.`;
      } else {
        
        //Check that there are no elements in rows with higher pricing than the base variant
        const higherValueExists = json[variantBarcode].find(e => e > variantPrice);
        const isSampleProduct = product.type === "Sample Pack";
        if (higherValueExists && !isSampleProduct) {
          isJsonValid = false;
          errorMessage += `\n- There is an element in ${variantBarcode} with value ${higherValueExists} that is higher than the variant's based price ${variantPrice}`;
        }
        
        json[variantBarcode].forEach((barcode, index) => {
          
          const isInt = Number(barcode) === barcode && barcode % 1 === 0;
          const isFloat = Number(barcode) === barcode && barcode % 1 !== 0;
          
          if (!isInt && !isFloat) {
            isJsonValid = false;
            errorMessage += `\n- ${barcode} in position ${index + 1} of ${variantBarcode} is neither an integer or a float.`;
          }
        })
      }
    });
    
    //Check that all arrays are the same length
    let keyLength = -1;
    Object.keys(json).every(key => {
      if (keyLength !== -1) {
        if (json[key].length !== keyLength) {
          isJsonValid = false;
          errorMessage += `\n- Not all array elements have the same length`;
          return false;
        }
      }
      keyLength = json[key].length;
      return true;
    });
    
    //Check if quantity_breaks elements are integers
    if (json.quantity_breaks) {
      const quantity_breaks = json.quantity_breaks;
      quantity_breaks.every((quantity, index) => {
        const isInt = Number(quantity) === quantity && quantity % 1 === 0;
        if (!isInt) {
          isJsonValid = false;
          errorMessage += `\n- ${quantity} in position ${index + 1} of quantity_breaks is not an integer.`
          return false;
        }
        return true;
      });
    }
    
    //Check if msrp_markup_multiplier elements are integers or floats
    if (json.msrp_markup_multiplier) {
      const msrp_markup_multiplier = json.msrp_markup_multiplier;
      msrp_markup_multiplier.forEach((msrp, index) => {
        const isInt = Number(msrp) === msrp && msrp % 1 === 0;
        const isFloat = Number(msrp) === msrp && msrp % 1 !== 0;

        if (!isInt && !isFloat) {
          isJsonValid = false;
          errorMessage += `\n${msrp} in position ${index + 1} of msrp_markup_multiplier is neither an integer or a float.`
        }
      })
    }
    
    
    callback({
      isJsonValid,
      errorMessage
    });
  });
}

/******** common for both product and cart pages ***end***/
